module.exports = __webpack_public_path__ + "static/media/logo-proursa-blanc.52996920.svg";